export default {
  navTab: ["Today's Schedule", 'My Schedule', 'Ended Schedule'],
  card: {
    group: 'My group: ',
    location: 'Address: ',
    viewCommitmentLetter: 'Commitment',
    signCommitmentLetter: 'Commitment',
    checkinPhoto: 'Check-in',
    interviewerCheckin: 'Checked-in',
    viewArrangement: 'Schedule',
  },
  noData: 'No Schedule',
  signOut: {
    confirmMsg: 'Are you sure to exit from the system?',
    cancelMsg: 'Cancel exit',
  },
  getSchedules401: 'Login expired, please log in again.',
};
